import Attrs from '../models/Attrs'
import type { PaypalCheckout } from '../models/types'

type ButtonStylesOptionKeys = 'color' | 'label' | 'layout' | 'shape' | 'size' | 'tagline'

const CONTROLLER = 'components--paypal-checkout'

export default function renderPaypalCheckout(component: PaypalCheckout, attrs: Attrs): string {
  attrs
    .addController(CONTROLLER)
    .addAction(
      `${CONTROLLER}:update->flow#update`,
      `${CONTROLLER}:next->flow#next`,
      `${CONTROLLER}:validate->flow#triggerFormValidation`,
      `${CONTROLLER}:actions->flow#dispatchAction`
    )

  const values = [
    { value: component.id, key: 'id' },
    { value: component.key, key: 'key' },
    { value: component.action, key: 'action' },
    { value: component.plan_id, key: 'plan-id' },
    { value: `${!!component.next_on_complete}`, key: 'success-action' },
    {
      value: component.amount === 0 ? '0' : (component.amount as string),
      key: 'amount',
    },
  ].filter((value) => !!value.value)
  values.forEach((data) => attrs.addValue(CONTROLLER, data.key, data.value))

  const options: ButtonStylesOptionKeys[] = ['color', 'label', 'layout', 'shape', 'size', 'tagline']
  options.forEach((option) => {
    const value = component.buttons_config?.[option]
    if (value) attrs.addValue(CONTROLLER, `button-${option}`, value)
  })

  const containerAttrs = new Attrs(attrs.static_render).addTarget(CONTROLLER, 'container')
  containerAttrs.add('id', `paypal-${component.id}`)

  const container = `<div ${containerAttrs}></div>`

  return `<div ${attrs}>${container}</div>`
}
